export default {
  recurring: 'recurring-payments',
  payouts: 'manual',
  remittance: 'remittance',
  businessDocs: 'maf',
} as const;
